import React from 'react';

import styles from './DocumentCaptureHeaderAndSummary.scss';

type DocumentCaptureHeaderAndSummaryProps = {
  header: string;
  summary: React.ReactNode;
}

const DocumentCaptureHeaderAndSummary = ({ header, summary }: DocumentCaptureHeaderAndSummaryProps) =>
  (<section className={styles.header}>
    <h1>{header}</h1>
    {summary}
  </section>);

export default DocumentCaptureHeaderAndSummary;
